import React, {FC} from "react";
import cls from "../../shop.module.scss";
import ProductImage from "../ProductImage";
import Currency from "../../../shared/Currency";
import InputNumber from "../../../shared/InputNumber";
import {ICartItemType} from "../../../../types/state";
import RemoveButton from "../RemoveButton";
import {quantitiesType} from "../../ShopPageCart";
import ProductColumnInfo from "../ProductColumnInfo";
import {FailSvg} from "../../../../svg";
import {useToast} from "../../../../atoms/Toast/useToast";

interface IMainProps {
    item: ICartItemType;
    DeleteIntl: string;
    onChangeCallBack: (quantity: number, item: ICartItemType) => void;
    quantities: quantitiesType[]
    maxQty: number;
    ProductNotAvailableIntl: string
}

const Main:FC<IMainProps> = ({item, DeleteIntl, onChangeCallBack, maxQty, quantities, ProductNotAvailableIntl}) => {
    const {
        product,
        options,
        formated_base_price: formattedProductPrice,
        id: itemId
    } = item;
    const toast = useToast();
    const clsHandle = (tabName: string) => ({
        className: `${cls["cart-table__column"]} ${cls[`cart-table__column--${tabName}`]}`
    })
    const quantityFindToggle = () => {
        const {
            value = item.quantity,
            min_qty = 1
        } = quantities.find(qty => qty.itemId === itemId) || {}
        return { value, min_qty };
    }
    const onChange = (quantities: number) => {
        if (maxQty <= quantities) {
            return toast.open(
                <span className="d-flex chek-fms">
                    <FailSvg/>
                    {ProductNotAvailableIntl}
                </span>
            )
        } else {
            return onChangeCallBack(quantities, item)
        }
    }
    return (
        <div className={cls.mobile_cart_header}>
            <div {...clsHandle("image")}>
                <ProductImage item={item}/>
            </div>
            <div className={cls.mobile_cart_info}>
                <div {...clsHandle("product")}>
                    <ProductColumnInfo product={product} options={options} />
                </div>
                <div {...clsHandle("price")}>
                    <Currency value={formattedProductPrice}/>
                </div>
                <div {...clsHandle("quantity")}>
                    <InputNumber
                        onChange={onChange}
                        hideMinusButton={
                            quantityFindToggle().value <= 1
                            || quantityFindToggle().min_qty === quantityFindToggle().value
                        }
                        value={quantityFindToggle().value}
                        min={quantityFindToggle().min_qty}
                        max={maxQty}
                        alternativelyRemoveButton={<RemoveButton isAlternative={true} cartItemId={itemId} DeleteIntl={DeleteIntl} />}
                    />
                </div>
            </div>
        </div>
    );
}

export default Main;
